/**
 * Default auth cookie lifetime (30 days).
 */
export const TOKEN_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;

/** js-cookie uses `expires` as number of days from now. */
export const TOKEN_COOKIE_EXPIRES_DAYS = 30;

export function getTokenCookieBaseOptions() {
  if (typeof window === "undefined") return { path: "/" };
  const hostname = window.location.hostname;
  const isQuizrrDomain = hostname === "quizrr.in" || hostname.endsWith(".quizrr.in");
  return isQuizrrDomain ? { domain: ".quizrr.in", path: "/" } : { path: "/" };
}

/** Options for react-cookie `setCookie` (maxAge is seconds). */
export function getReactCookieTokenOptions(overrides = {}) {
  const secure = typeof window !== "undefined" && window.location.protocol === "https:";
  return {
    ...getTokenCookieBaseOptions(),
    maxAge: TOKEN_COOKIE_MAX_AGE_SECONDS,
    sameSite: "lax",
    secure,
    ...overrides,
  };
}

/** Options for js-cookie `Cookies.set` (expires = days). */
export function getJsCookieTokenOptions(overrides = {}) {
  const secure = typeof window !== "undefined" && window.location.protocol === "https:";
  return {
    ...getTokenCookieBaseOptions(),
    expires: TOKEN_COOKIE_EXPIRES_DAYS,
    sameSite: "lax",
    secure,
    ...overrides,
  };
}
